<template>
  <div :class="$style['base-engagement-tool']">
    <engagement-layout source="basicscreen">
      <template #heading>{{ pageHeadingInfo.heading }} </template>
      <!-- <template #info-tooltip>{{ pageHeadingInfo.headingIconText }} </template> -->
      <template #sub-heading>{{ pageHeadingInfo.subHeading }}</template>

      <template #left-side-bar>
        <div :class="$style['left-body-container']">
          <adl-card-dropdown
            :title="cardData.description"
            firstButtonText="Create New"
            secondButtonText="Select Existing"
            :imagepath="cardData.imagepath"
            :firstOptionLabel="firstOptionLabel"
            :secondOptionLabel="secondOptionLabel"
            :showdropdown="showdropdown"
            :firstSelectData="firstSelectData"
            :secondSelectData="secondSelectData"
            :imageheight="imageheight"
            :imagewidth="imagewidth"
            @ListItemChange="ChangeUserLoanInfo"
          ></adl-card-dropdown>

          <div :class="$style['engagement-form']">
            <adl-eloqua-form
              :data="formModel"
              :loading="loading"
              @submit="submitForm"
              @reset="resetForm"
              @formChange="formChange"
              @refresh="refreshValue"
              @linkClick="linkClick"
              @OnEdit="EditAdditionalForm"
              @dropDownChange="dropDownChange"
            >
            </adl-eloqua-form>
          </div>
          <div :class="[$style['cfSet'], $style['relatedGoalsWrapper']]">
            <link-goal :linkGoalInfo="linkGoalInfo"></link-goal>
          </div>
        </div>
      </template>

      <template #right-side-bar>
        <div
          v-if="!isShowEmptyState"
          class="right-body-container right-body-white-container"
        >
          <div :class="$style['graph-selection-view']">
            <graph-selection
              :buttonDataTypeConfig="buttonDataTypeConfig"
              :buttonViewTypeConfig="buttonViewTypeConfig"
              @onSelectDataTypeFilter="onSelectDataTypeFilter"
              @onSelectViewTypeFilter="onSelectViewTypeFilter"
            ></graph-selection>
          </div>
          <chart-selection
            :chartTabContent="chartTabContent"
            :height="390"
            @onSelectedTab="onSelectedTab"
          >
            <template v-slot:right-side-section>
              <div v-if="isShowDownloadIcon">
                <mds-button
                  variation="secondary"
                  :class="$style['upload-link-label']"
                  @click="toggleReportOption = !toggleReportOption"
                  icon="document"
                  id="reportType"
                  type="button"
                >
                  Create Report
                </mds-button>
                <mds-popover
                  width="200px"
                  v-if="toggleReportOption"
                  triggered-by="reportType"
                  v-model="toggleReportOption"
                  :position="['bottom-right']"
                >
                  <ul class="report-container">
                    <li
                      class="upload-link-list"
                      v-for="key in downloadOption"
                      :key="key.value"
                    >
                      <div class="upload-link-container">
                        <img :src="key.iconPath" class="report-icon" />
                        <span
                          href="#"
                          v-on:click="downloadExcelFile(key.value)"
                          class="upload-link"
                          >{{ key.text }}</span
                        >
                      </div>
                    </li>
                  </ul>
                </mds-popover>
              </div>

              <adl-input-format
                :label="'Projection Year'"
                :class="$style['projectionPosition']"
                size="small"
                :value="0"
                v-model="projectionYear.Value"
                appendText=""
                :maxlength="3"
                :maxvalue="projectionYear.Maxvalue"
                :isAllowOnlyNumber="true"
                :isAllowOnlyInteger="true"
                currencyFormat=""
                :isError="projectionYear.IsError"
                :errorText="projectionYear.ErrorText"
                @change="changeProjectionYear($event)"
                @submit="submitProjectionYear($event)"
              ></adl-input-format>
            </template>
            <template v-slot:tabBody>
              <component
                :is="selectedComponent"
                :chartProperties="chartProperties"
                :chartData="chartData"
                :TableSettings="tableViewSettings"
                :ShowTableView="showTableView"
                v-if="chartData.length > 0"
              ></component>
            </template>
          </chart-selection>
          <summary-block
            v-if="!showTableView"
            :leftToolSummary="leftToolSummary"
            :rightToolSummary="rightToolSummary"
          ></summary-block>
        </div>
        <div
          class="right-body-container right-body-white-container emptychartbox"
          v-else
        >
          <div class="emptychartboxicon">
            <!-- <mds-icon name="ip-super-sector-sensitive"></mds-icon> -->

            <img alt="nochart" src="../../assets/no-chart-data.svg" />
          </div>
          <div class="emptychartboxpadding">
            {{ emptyChartMessage.message }}
          </div>
        </div>
      </template>

      <template #footer>
        <page-footer>
          <template #action-button-left>
            <mds-button
              size="large"
              variation="flat"
              icon="caret-left"
              @click="onBackButtonClick"
            >
              Back
            </mds-button>
          </template>
          <template #action-button-right>
            <mds-button
              type="button"
              variation="secondary"
              @click="cancelButtonClick"
            >
              Cancel
            </mds-button>
            <mds-button
              type="button"
              variation="primary"
              @click="saveButtonClick"
            >
              Save
            </mds-button>
          </template>
        </page-footer>
      </template>
    </engagement-layout>
  </div>
</template>

<script>
import { EngagementLayout } from "../../component";
import GraphSelection from "../tool/graph-selection.vue";
import { PageFooter } from "../../component";
import AdlEloquaForm from "../custom/eloqua-form/EloquaForm.vue";
import { ChartArea, ChartBar } from "../tool";
import { MdsTabs, MdsTabsItem } from "@mds/tabs";
import { LinkGoal, SummaryBlock, ChartSelection } from "../../component/tool";
import { MdsButton } from "@mds/button";
import AdlCardDropdown from "../custom/CardDropdown/CardDropdown.vue";
import MdsPopover from "@mds/popover";
import AdlInputFormat from "../custom/input-format/InputFormat.vue";

export default {
  props: {
    cardData: {
      type: Object,
    },
    pageHeadingInfo: {
      type: Object,
    },
    linkGoalInfo: {
      type: Object,
    },
    leftToolSummary: {
      type: Array,
    },
    rightToolSummary: {
      type: Array,
    },
    formModel: {
      type: Object,
    },
    downloadOption: {
      type: Array,
    },
    downloadLabelName: {
      type: String,
    },

    chartTabContent: {
      type: Array,
    },
    firstSelectData: {
      type: Array,
    },
    secondSelectData: {
      type: Array,
    },
    chartProperties: {
      type: Object,
    },
    chartData: {
      type: Array,
    },
    selectedComponent: {
      type: String,
    },
    firstOptionLabel: {
      type: Object,
    },
    secondOptionLabel: {
      type: Object,
    },
    imageheight: {
      type: String,
    },
    imagewidth: {
      type: String,
    },
    projectionYear: {
      type: Object,
    },
    isShowEmptyState: {
      type: Boolean,
    },
    emptyChartMessage: {
      type: Object,
    },
    isShowDownloadIcon: {
      type: Boolean,
    },
    showTableView: {
      type: Boolean,
      default: false,
    },
    tableViewSettings: {
      type: Object,
    },
    buttonDataTypeConfig: {
      type: Array,
    },
    buttonViewTypeConfig: {
      type: Array,
    },
  },
  components: {
    AdlCardDropdown,
    MdsButton,
    ChartArea,
    ChartBar,
    ChartSelection,
    EngagementLayout,
    LinkGoal,
    MdsPopover,
    SummaryBlock,
    AdlEloquaForm,
    PageFooter,
    MdsTabs,
    MdsTabsItem,
    AdlInputFormat,
    GraphSelection,
  },
  data() {
    return {
      showdropdown: true,
      toggleReportOption: false,
      loading: false,
      cancelButtonToggle: false,
      saveButtonToggle: true,
      backButtonToggle: false,
    };
  },
  computed: {},

  methods: {
    onSelectDataTypeFilter(button, item, filterType) {
      this.$emit("onSelectDataTypeFilter", button, item, filterType);
    },

    onSelectViewTypeFilter(button, item, filterType) {
      this.$emit("onSelectViewTypeFilter", button, item, filterType);
    },
    dropDownChange(callBackMethod, data) {
      this.$emit("dropDownChange", callBackMethod, data);
    },
    onSelectedTab(tabId) {
      this.$emit("onChangeChartTab", tabId);
    },
    submitProjectionYear() {
      this.$emit("submit");
    },
    cancelButtonClick() {
      this.$emit("cancelInstance", {});
    },
    saveButtonClick() {
      this.$emit("saveInstance", {});
    },
    onBackButtonClick() {
      this.$emit("onBack", {});
    },
    ChangeUserLoanInfo(loanInfo) {
      this.$emit("changeLoanInfo", loanInfo);
    },
    submitForm(form) {
      this.$emit("submit", form);
    },
    resetForm(form) {
      this.$emit("reset", form);
    },
    formChange(form) {
      this.$emit("formChange", form);
    },
    refreshValue() {
      this.$emit("refresh");
    },
    linkClick(function_name) {
      this.$emit("linkClick", function_name);
    },
    EditAdditionalForm(data) {
      this.$emit("EditAdditionalform", data);
    },
    changeProjectionYear(data) {
      this.$emit("changeProjectionYear", data);
    },
    downloadExcelFile(fileType) {
      this.$emit("downloadExcelFile", fileType);
    },
    ListItemChange() {},
  },
};
</script>

<style lang="scss" module>
@import "@mds/link";
.base-engagement-tool {
  .upload-link-label {
    margin-right: 120px;

    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 21px;
  }
  .cfSet {
    width: 100%;
    float: left;
  }
  .projectionPosition {
    position: absolute;
    top: -7px;
    right: 0;
    width: 110px;
    .mds-input__field-error-wrapper {
      position: absolute;
      right: 0;
    }
  }
  .left-body-container {
    .engagement-form {
      margin-top: $mds-space-2-x;
      margin-bottom: $mds-space-3-x;
    }
    .relatedGoalsWrapper {
      .mds-section--tertiary {
        padding-top: $mds-space-2-x;
      }
    }
  }
}
</style>
